import { GenderTypes } from './enums';

export const DEFAULT_LOCALE = 'en';
export const GENDER_TYPES = [GenderTypes.MALE, GenderTypes.FEMALE];

export const APP_TITLE = process.env.REACT_APP_TITLE;
export const APP_NAME = process.env.REACT_APP_NAME;
export const API_URL = process.env.REACT_APP_API_URL;
export const PUBLIC_LOGIN_URL =
  API_URL + process.env.REACT_APP_API_PUBLIC_LOGIN_PATH;
export const PUBLIC_SAVE_URL =
  API_URL + process.env.REACT_APP_API_PUBLIC_SAVE_PATH;

export const PRIVATE_SINGAPORE_VIA_ENV = process.env.REACT_APP_PRIVATE;
export const PRIVATE_SINGAPORE_DOMAIN =
  process.env.REACT_APP_PRIVATE_SINGAPORE_DOMAIN || '';

export const SizeTypes = [
  { label: 't', value: 2 },
  { label: 's', value: 4 },
  { label: 'm', value: 6 },
  { label: 'l', value: 8 },
  { label: 'xl', value: 10 }
];

export const SPORT_ICONS_URL = process.env.REACT_APP_SPORT_ICONS_URL;



// WEBPACK FOOTER //
// ./src/constants.ts